import { Session } from "@chromia/ft4";

import { iChrItem, iTypedGtxClient, tDiscountPercent } from "../../interfaces";
import { tDispatch } from "../store";
import { eChromiaActionTypes } from "./chromiaTypes";

export const clearChrState = () => {
	return (dispatch: tDispatch) => {
		dispatch({
			type: eChromiaActionTypes.CLEAR_STATE,
		})
	}
}

export const setSession = (session: Session) => {
	return (dispatch: tDispatch) => {
		dispatch({
			type: eChromiaActionTypes.SET_SESSION,
			payload: session
		})
	}
}

export const setChrClientAddr = (address: string) => {
	return (dispatch: tDispatch) => {
		dispatch({
			type: eChromiaActionTypes.SET_CHR_CLIENT_ADDR,
			payload: address
		})
	}
}

export const setGtxClient = (client: iTypedGtxClient) => {
	return (dispatch: tDispatch) => {
		dispatch({
			type: eChromiaActionTypes.SET_GTX_CLIENT,
			payload: client
		})
	}
}

export const setIsChrRegistered = (state: boolean) => {
	return (dispatch: tDispatch) => {
		dispatch({
			type: eChromiaActionTypes.SET_IS_CHR_REGISTERED,
			payload: state
		})
	}
}

export const setItem = (percent: tDiscountPercent, item: iChrItem) => {
	return (dispatch: tDispatch) => {
		dispatch({
			type: eChromiaActionTypes.SET_ITEM,
			payload: {
				percent,
				item
			}
		})
	}
}

export const setEndTime = (percent: tDiscountPercent, endTime: number) => {
	return (dispatch: tDispatch) => {
		dispatch({
			type: eChromiaActionTypes.SET_END_TIME,
			payload: {
				percent,
				endTime
			}
		})
	}
}